import React, { useState } from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  Paper,
  Typography,
  TablePagination,
} from '@mui/material';
import UnitRow from './UnitRow';

const HEADER_CELL_SX = {
  fontWeight: 700,
  fontSize: '0.75rem',
  textTransform: 'uppercase',
  letterSpacing: 0.5,
  color: 'text.secondary',
  bgcolor: 'rgba(46, 125, 50, 0.06)',
  borderBottom: 1,
  borderColor: 'divider',
};

const ROWS_PER_PAGE_OPTIONS = [10, 25, 50, 100];

function InventorySearchTable({
  units,
  onProjectClick,
  onConfigClick,
  onBook,
  onView,
}) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [selected, setSelected] = useState(new Set());

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelected(new Set(units.map((u) => u.id)));
    } else {
      setSelected(new Set());
    }
  };

  const handleSelectOne = (id, checked) => {
    setSelected((prev) => {
      const next = new Set(prev);
      if (checked) next.add(id);
      else next.delete(id);
      return next;
    });
  };

  const paginatedUnits = units.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  const allSelected = units.length > 0 && selected.size === units.length;

  return (
    <Paper variant="outlined" sx={{ overflow: 'hidden', borderRadius: 2 }}>
      <TableContainer sx={{ maxHeight: 'calc(100vh - 320px)' }}>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell padding="checkbox" sx={HEADER_CELL_SX}>
                <Checkbox
                  indeterminate={selected.size > 0 && selected.size < units.length}
                  checked={allSelected}
                  onChange={handleSelectAll}
                  size="small"
                  color="primary"
                />
              </TableCell>
              <TableCell sx={HEADER_CELL_SX}>Unit ID</TableCell>
              <TableCell sx={HEADER_CELL_SX}>Project</TableCell>
              <TableCell sx={HEADER_CELL_SX}>Config</TableCell>
              <TableCell sx={HEADER_CELL_SX}>Category</TableCell>
              <TableCell sx={HEADER_CELL_SX}>Floor · Tower</TableCell>
              <TableCell sx={HEADER_CELL_SX}>Area</TableCell>
              <TableCell align="right" sx={HEADER_CELL_SX}>Price</TableCell>
              <TableCell sx={HEADER_CELL_SX}>Status</TableCell>
              <TableCell sx={HEADER_CELL_SX}>Channel Partner</TableCell>
              <TableCell sx={HEADER_CELL_SX}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedUnits.map((unit) => (
              <UnitRow
                key={unit.id}
                unit={unit}
                selected={selected.has(unit.id)}
                onSelect={(checked) => handleSelectOne(unit.id, checked)}
                onProjectClick={onProjectClick}
                onConfigClick={onConfigClick}
                onBook={onBook}
                onView={onView}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        component="div"
        count={units.length}
        page={page}
        onPageChange={(_, p) => setPage(p)}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={(e) => {
          setRowsPerPage(parseInt(e.target.value, 10));
          setPage(0);
        }}
        rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
        sx={{ borderTop: 1, borderColor: 'divider' }}
      />
    </Paper>
  );
}

export default InventorySearchTable;
